export const PRODUCTION_HOSTS = [
    'ca-web-north-eu-webapp.azurewebsites.net',
    'chargeampsweb.azurewebsites.net',
    'my.charge.space',
    'fortum.charge.space',
]
export const STAGING_HOSTS = [
    'ca-web-north-eu-webapp-staging.azurewebsites.net',
    'chargeampsweb-stage.azurewebsites.net',
    'mys.charge.space',
    'fortums.charge.space',
]
export const DEV_HOSTS = [
    'ca-web-webapp-dev.azurewebsites.net',
    'chargeampsweb-dev.azurewebsites.net',
    'myd.charge.space',
    'myz.charge.space',
]
export const TEST_HOSTS = ['chargeampsweb-test.azurewebsites.net', 'myt.charge.space']
export const LOCAL_HOSTS = ['localhost']
